import { FormattedMessage } from 'react-intl'
import { useSmartBack } from '@hooks/useSmartBack'

import './BackButton.css'

export default function BackButton() {
  const { goBack } = useSmartBack('/')
  return (
    <button className="button back-button" onClick={goBack}>
      <span className="icon icon-angle-left" />
      <span className="text">
        <FormattedMessage id="back" />
      </span>
    </button>
  )
}
